<template>
  <div>
    <div
      class="modal hide fade"
      id="modalPaymentPurchasing"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPaymentPurchasing"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Purchasing Payment - {{ purchasing.purchasing_no }} - {{ idNew }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <label
                    for="payment_date"
                    class="col-sm-3 col-form-label text-left"
                    >Date</label
                  >
                  <div class="col-sm-9">
                    <datetime
                      v-model="paymentId.payment_date"
                      format="dd/MM/yyyy"
                      class="form-control"
                      value-zone="local"
                      zone="local"
                    ></datetime>
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="method_id"
                    class="col-sm-3 col-form-label text-left"
                    >Method</label
                  >
                  <div class="col-sm-9">
                    <select
                      v-model="paymentId.method_id"
                      class="form-control"
                      id="method_id"
                    >
                      <option v-for="m in methodList" :key="m.id" :value="m.id">
                        {{ m.name }}
                      </option>
                    </select>
                  </div>
                </div>
                ,
                <div class="form-group row">
                  <label for="bank_id" class="col-sm-3 col-form-label text-left"
                    >Bank</label
                  >
                  <div class="col-sm-9">
                    <select
                      class="form-control"
                      v-model="paymentId.bank_id"
                      id="bank_id"
                    >
                      <option value="">---</option>
                      <option v-for="b in bankList" :key="b.id" :value="b.id">
                        [{{ b.account_no }}] - {{ b.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="method_id"
                    class="col-sm-3 col-form-label text-left"
                    >Amount</label
                  >
                  <div class="col-sm-9">
                    <input
                      type="text"
                      v-money="moneyPayment"
                      v-model="paymentId.price"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="notes" class="col-sm-3 col-form-label text-left"
                    >Notes</label
                  >
                  <div class="col-sm-9">
                    <textarea
                      type="text"
                      v-model="paymentId.notes"
                      class="form-control"
                      id="notes"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm pull-left"
              data-dismiss="modal"
              @click="cancelPayment"
            >
              <i class="fa fa-times"></i> Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              data-dismiss="modal"
              @click="savePayment"
            >
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PurchasingPaymentModal',
  props: ['purchasing', 'idNew'],
  data () {
    return {
      moneyPayment: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      typeList: (state) => state.payments.typeList,
      methodList: (state) => state.payments.methodList,
      bankList: (state) => state.banks.bankList
    }),
    paymentId: function () {
      var payment = this.purchasing.payment.find((d) => d.id === this.idNew)
      if (payment) {
        return payment
      } else {
        return [
          {
            id: null,
            payment_no: null,
            purchasing_no: null,
            payment_date: null,
            price: '0',
            method_id: null,
            method: null,
            type_id: null,
            type: null,
            bank_id: null,
            bank: null,
            account_no: null,
            notes: null
          }
        ]
      }
    }
  },
  methods: {
    savePayment: function () {
      this.paymentId.method = this.methodList.find(
        (d) => d.id === this.paymentId.method_id
      ).name
      if (this.paymentId.bank_id !== '') {
        var bank = this.bankList.find((d) => d.id === this.paymentId.bank_id)
        this.paymentId.bank = bank.name
        this.paymentId.account_no = bank.account_no
      } else {
        this.paymentId.bank_id = null
      }
      this.paymentId.price = this.paymentId.price.replace(/\./g, '')
    },
    cancelPayment: function () {
      this.$emit('backToPayment', this.paymentId.id)
    }
  }
}
</script>
